import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import LinkedserviceList from '@/modules/linkedservice/views/LinkedserviceList.vue'
import LinkedserviceCreate from '@/modules/linkedservice/views/LinkedserviceCreate.vue'

const baseRoute = OneNetworkConfig.baseRoutePath
const linkedServiceRouter = [
  {
    path: `${baseRoute}/services/list`,
    name: 'liked-services',
    meta: {
      component: LinkedserviceList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/services/create`,
    name: 'liked-services-create',
    meta: {
      component: LinkedserviceCreate
    },
    component: PrivateRouter,
  },
]
export default linkedServiceRouter
